export const getOptions = (intl) => {
  return {
    OCCURRENCE_PERIOD_OPTIONS: [
      {
        value: 'Hour',
        label: intl.formatMessage({
          id: 'AlertModalOptions.hours',
          defaultMessage: 'Hour(s)',
          description: 'Time period option for hours',
        }),
      },
      {
        value: 'Day',
        label: intl.formatMessage({
          id: 'AlertModalOptions.days',
          defaultMessage: 'Day(s)',
          description: 'Time period option for days',
        }),
      },
      {
        value: 'Week',
        label: intl.formatMessage({
          id: 'AlertModalOptions.weeks',
          defaultMessage: 'Week(s)',
          description: 'Time period option for weeks',
        }),
      },
    ],
    OCCURRENCE_END_TIMESPAN_OPTIONS: [
      {
        value: 'never',
        label: intl.formatMessage({
          id: 'AlertModalOptions.never',
          defaultMessage: 'Never',
          description: 'Option for alerts that never end',
        }),
      },
      {
        value: 'on_a_specific_date',
        label: intl.formatMessage({
          id: 'AlertModalOptions.onSpecificDate',
          defaultMessage: 'On a specific date',
          description: 'Option for alerts ending on a specific date',
        }),
      },
      {
        value: 'number_of_occurrences',
        label: intl.formatMessage({
          id: 'AlertModalOptions.numberOfOccurrences',
          defaultMessage: '# of occurrences',
          description: 'Option for alerts ending after a number of occurrences',
        }),
      },
    ],
    DATE_PERIOD_OPTIONS: [
      {
        value: 'Day',
        label: intl.formatMessage({
          id: 'AlertModalOptions.days',
          defaultMessage: 'Day(s)',
          description: 'Time period option for days',
        }),
      },
      {
        value: 'Week',
        label: intl.formatMessage({
          id: 'AlertModalOptions.weeks',
          defaultMessage: 'Week(s)',
          description: 'Time period option for weeks',
        }),
      },
      {
        value: 'Month',
        label: intl.formatMessage({
          id: 'AlertModalOptions.months',
          defaultMessage: 'Month(s)',
          description: 'Time period option for months',
        }),
      },
      {
        value: 'Year',
        label: intl.formatMessage({
          id: 'AlertModalOptions.years',
          defaultMessage: 'Year(s)',
          description: 'Time period option for years',
        }),
      },
    ],
  };
};

export const DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
